var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickFade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_10841)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12.9752C5 10.3296 6.05096 7.7924 7.92168 5.92168C9.7924 4.05096 12.3296 3 14.9752 3C17.6208 3 20.1581 4.05096 22.0288 5.92168C23.8995 7.7924 24.9505 10.3296 24.9505 12.9752C24.9505 15.6208 23.8995 18.1581 22.0288 20.0288C20.1581 21.8995 17.6208 22.9505 14.9752 22.9505C12.3296 22.9505 9.7924 21.8995 7.92168 20.0288C6.05096 18.1581 5 15.6208 5 12.9752H5ZM14.406 17.2446L20.1491 10.0651L19.1116 9.23519L14.2145 15.3547L10.7457 12.4645L9.89452 13.486L14.406 17.246V17.2446Z",
    fill: "#CDCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56813 5.56813C5.72181 7.41444 4.63589 9.87901 4.51193 12.4752H4.5V12.9752C4.5 15.7534 5.60364 18.4179 7.56813 20.3824C9.53262 22.3468 12.197 23.4505 14.9752 23.4505C17.7534 23.4505 20.4179 22.3468 22.3824 20.3824C24.3468 18.4179 25.4505 15.7534 25.4505 12.9752C25.4505 10.197 24.3468 7.53262 22.3824 5.56813C20.4179 3.60364 17.7534 2.5 14.9752 2.5C12.197 2.5 9.53262 3.60364 7.56813 5.56813ZM14.3336 16.5347L10.5987 13.422L10.8098 13.1687L13.8944 15.7388L14.2862 16.0653L14.6048 15.6671L19.1897 9.93792L19.4463 10.1432L14.3336 16.5347Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_10841",
    x: 0,
    y: 0,
    width: 29.9507,
    height: 29.9504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_10841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_10841",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFade);
export default __webpack_public_path__ + "static/media/tick-fade.84f5f47a0036bd1c81779a529557836e.svg";
export { ForwardRef as ReactComponent };